/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {ProductBorderStyleType} from '../../../../constants';

export const getGridGalleryCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const getBorderStyleCssVars = () => {
    const isOutline = styleParams.numbers.productPage_galleryImageBorderStyleType;
    const gallerySpacingBetweenRows: number = styleParams.numbers.productPage_gallerySpacingBetweenRows;
    const gallerySpacingBetweenCols: number = styleParams.numbers.productPage_gallerySpacingBetweenColumns;
    const gallerySpacingBetweenColsOutline = Math.min(1, styleParams.numbers.productPage_gallerySpacingBetweenColumns);
    const gallerySpacingBetweenRowsOutline = Math.min(1, styleParams.numbers.productPage_gallerySpacingBetweenRows);
    const galleryImageBorderSize = styleParams.numbers.productPage_galleryImageBorderSize;

    if (isOutline === ProductBorderStyleType.OUTLINE) {
      const gridRowGap =
        gallerySpacingBetweenRows + (galleryImageBorderSize / 2) * 2 * gallerySpacingBetweenRowsOutline;
      const gridColGap =
        gallerySpacingBetweenCols + (galleryImageBorderSize / 2) * 2 * gallerySpacingBetweenColsOutline;

      return {
        imageGridRowGap: `${gridRowGap}px`,
        imageGridColGap: `${gridColGap}px`,
        borderRadius: `${styleParams.numbers.productPage_galleryImageCornerRadius}px`,
        borderColor: styleParams.colors.productPage_galleryBorderColor,
        borderStyle: 'solid',
        borderWidth: `${galleryImageBorderSize / 2}px`,
        outlineColor: styleParams.colors.productPage_galleryBorderColor,
        outlineStyle: 'solid',
        outlineWidth: `${galleryImageBorderSize / 2}px`,
      };
    }

    return {
      imageGridRowGap: `${gallerySpacingBetweenRows}px`,
      imageGridColGap: `${gallerySpacingBetweenCols}px`,
      borderRadius: `${styleParams.numbers.productPage_galleryImageCornerRadius}px`,
      borderColor: styleParams.colors.productPage_galleryBorderColor,
      borderStyle: 'solid',
      borderWidth: `${galleryImageBorderSize}px`,
    };
  };

  return {
    ...getBorderStyleCssVars(),
  };
};
